import { render, staticRenderFns } from "./MainChartTabs.vue?vue&type=template&id=5fe4db90&scoped=true&"
import script from "./MainChartTabs.vue?vue&type=script&lang=js&"
export * from "./MainChartTabs.vue?vue&type=script&lang=js&"
import style0 from "./MainChartTabs.vue?vue&type=style&index=0&id=5fe4db90&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe4db90",
  null
  
)

export default component.exports